import script from "./BaseTemplateMain.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateMain.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateMain.vue?vue&type=style&index=0&id=23aeddf8&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23aeddf8"]])

export default __exports__